// extracted by mini-css-extract-plugin
module.exports = {"headingTwo":"aboutus-page-module--headingTwo--2Sit5"};